const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/devices/route.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/devices/route.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { CalibrationDevicesRail } from '@/features/calibration/components/CalibrationDevicesRail';
import { DevicesPendingState } from '@/features/calibration/components/DevicesPendingState';
import { calibrationStationsQuery } from '@/features/calibration/services/calibrationQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/calibration/devices')({
  loader: ({
    context
  }) => context.queryClient.ensureInfiniteQueryData(calibrationStationsQuery()),
  pendingComponent: DevicesPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  staticData: {
    sectionShell: {
      secondarySidebar: CalibrationDevicesRail
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});